export default "__VITE_ASSET__36f72e51__"